import { ref, computed, reactive, toRefs } from 'vue'
import moment from 'moment'
import { addMediaTag, updateMediaTag, syncMediaTag, getMediaTagList } from '@/api/material.model.js'
import { MEDIAS } from '@/common/js/constants.js'
function getFormFields() {
  return {
    mediaId: MEDIAS.GDT,
    adAccountIds: [],
    adAccountId: '',
    tagName: ''
  }
}
export const useMediaTagPage = () => {
  const mediaTagPage = reactive({
    queryForm: {
      keyword: ''
    },
    pager: {
      pageIndex: 1,
      pageSize: 30
    },
    tableData: [],
    tableLoading: false,
    tableHeight: 330,
    total: 0
  })
  const getTableData = () => {
    mediaTagPage.tableLoading = true
    getMediaTagList({ ...mediaTagPage.pager, ...mediaTagPage.queryForm }).then(data => {
      const { list, page_info } = data
      if (Array.isArray(list)) {
        mediaTagPage.tableData = list.map(row => {
          return {
            ...row,
            createTimeText: row.createTime ? moment(row.createTime).format('YYYY-MM-DD HH:mm:ss') : '-',
            updateTimeText: row.updateTime ? moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss') : '-'
          }
        })
        mediaTagPage.total = page_info?.total_number || 0
      } else {
        mediaTagPage.tableData = []
        mediaTagPage.total = 0
      }
    }).finally(() => {
      mediaTagPage.tableLoading = false
    })
  }

  return {
    ...toRefs(mediaTagPage),
    getTableData

  }
}

export const useMediaTagSyncForm = (getTableData) => {
  const syncFormModel = reactive({
    syncModal: false,
    syncFormRef: null,
    syncForm: getFormFields(),
    syncLoading: false
  })

  const onSyncModalConfirm = async () => {
    try {
      await syncFormModel.syncFormRef.validate()
      const { adAccountIds } = syncFormModel.syncFormRef.getForm()
      syncFormModel.syncLoading = true
      syncMediaTag({ accountIds: adAccountIds }).then(data => {
        if (data) {
          syncFormModel.syncModal = false
          getTableData()
        }
      }).finally(() => {
        syncFormModel.syncLoading = false
      })

      // console.log('formValue output: ', formValue)
    } catch (e) {
      console.log('onSyncModalConfirm error output: ', e)
    }
  }

  const onSyncModalClose = () => {
    syncFormModel.syncModal = false
    syncFormModel.syncForm = getFormFields()
  }

  return { ...toRefs(syncFormModel), onSyncModalConfirm, onSyncModalClose }
}

export const useMediaTagAddForm = (getTableData) => {
  const addFormModel = reactive({
    addModal: false,
    addFormRef: null,
    addForm: getFormFields(),
    confirmLoading: false
  })

  const onAddModalConfirm = async () => {
    try {
      await addFormModel.addFormRef.validate()
      const { adAccountId, tagName, tagId } = addFormModel.addFormRef.getForm()
      addFormModel.confirmLoading = true

      ; (tagId ? updateMediaTag({ tagId, accountId: adAccountId, mediaTagName: tagName }) : addMediaTag({ accountId: adAccountId, mediaTagName: tagName, mediaTagType: 'BUSINESS_SCENARIO_DELIVERY' })).then(data => {
        if (data) {
          addFormModel.addModal = false
          getTableData()
        }
      }).finally(() => {
        addFormModel.confirmLoading = false
      })
    } catch (e) {
      console.log('onSyncModalConfirm error output: ', e)
    }
  }

  const onAddModalClose = () => {
    addFormModel.addModal = false
    addFormModel.addForm = getFormFields()
  }

  return { ...toRefs(addFormModel), onAddModalClose, onAddModalConfirm }
}
